import { takeLatest, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { BACK_TO_SEARCH_RESULTS } from '../actions';
import * as AgentsSelectors from 'store/modules/agents/selectors';
import * as FastSearchSelectors from 'store/modules/fastSearch/selectors';
import qs from 'qs';

export function* backToSearchResultsSaga() {
  // Get selected company and TA to preserve in URL
  const selectedCompany = yield select(AgentsSelectors.selectedCompanySelector);
  const selectedTa = yield select(AgentsSelectors.selectedTaSelector);

  // Get current search query to preserve all search parameters
  const currentSearchQuery = yield select(FastSearchSelectors.offersQuerySelector);

  // Build query parameters including both search query and company/TA UUIDs
  const queryParams = {
    ...currentSearchQuery,
    ...(selectedCompany?.uuid && { companyUuid: selectedCompany.uuid }),
    ...(selectedTa?.uuid && { tauuid: selectedTa.uuid }),
  };

  // Navigate with preserved URL parameters
  const searchUrl = Object.keys(queryParams).length > 0 ? `/search/beta?${qs.stringify(queryParams)}` : '/search/beta';

  yield put(push(searchUrl));
}

export function* watchBackToSearchResults() {
  yield takeLatest(BACK_TO_SEARCH_RESULTS, backToSearchResultsSaga);
}
